export default __webpack_public_path__ + "static/media/language.8e050a59.svg";